module.exports = __webpack_public_path__ + "img/u.e3059b43.png";